import { RoleOutputDTO } from '@types';

export const RoleMapper = {
  toDTO: (data: Partial<RoleOutputDTO>): Partial<RoleOutputDTO> => {
    return {
      ...data,
    };
  },

  toView: (data: RoleOutputDTO): RoleOutputDTO => {
    return data; // Return the same object for now, can be expanded if needed
  },
}; 